import { EmployerFooter, EmployerHeader } from '@seek/adv-header-footer';
import type { Locale } from '@seek/melways-sites';
import { Box, Page, PageBlock, Stack } from 'braid-design-system';
import React from 'react';
import type { HeaderFooterContext } from '../../generated/graphql-types';
import type { EmployerSiteName } from '../../../types';

interface HeaderAndFooterWrapperProps {
  locale: Locale;
  accountInfo?: HeaderFooterContext;
  site: EmployerSiteName;
  isStaging: boolean;
}

export const HeaderAndFooterWrapper: React.FunctionComponent<
  React.PropsWithChildren<HeaderAndFooterWrapperProps>
> = ({ children, locale, accountInfo, site, isStaging }) => (
  <Page
    footer={
      <EmployerFooter
        locale={locale}
        site={site}
        isStaging={isStaging}
        advertiser={accountInfo?.advertiser}
        identityContext={accountInfo?.identityContext}
      />
    }
  >
    <Stack space="xlarge">
      <EmployerHeader
        id="employer-header"
        locale={locale}
        site={site}
        isStaging={isStaging}
        advertiser={accountInfo?.advertiser}
        identityContext={accountInfo?.identityContext}
        user={accountInfo?.user}
        divider
      />
      <Box component="main">
        <PageBlock width="small">{children}</PageBlock>
      </Box>
    </Stack>
  </Page>
);
